import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { useQuery } from '@apollo/client';
import { getCategoriesData } from '../../../../../utils/helpers/search';
import { Category } from './types';
import { FiltersOptionsWrapper, chipsStyles } from '../styled';
import { Chips } from '../../../../ui/Chips';
import { FiltersSection } from '../FiltersSection';
import useBugsnagNotifier from '../../../../../hooks/useBugsnagNotifier';
import { getCategories } from '../../../../../api/queries';
import { fillCategoriesWithData } from '../../../../../utils/helpers/fillCategoriesWithData';

export const NewSearchCategory = () => {
  const { data, error } = useQuery(getCategories);
  const { values } = useFormState();
  const { change } = useForm();
  const {
    t,
    i18n: { language }
  } = useTranslation();
  const categoriesData = getCategoriesData({ data, language });
  const filledCategories: Category[] = fillCategoriesWithData(categoriesData);

  useBugsnagNotifier(error);

  const handleChangeOption = (itemId: string) => {
    change('category_id', itemId);
  };

  return (
    <FiltersSection title={t('new_search.type_estate')}>
      <FiltersOptionsWrapper>
        {filledCategories.map(category => (
          <Chips
            text={category.name}
            value={category.id}
            type="button"
            hasCustomOnChange
            key={`category-${category.id}`}
            storedValue={values.category_id}
            onClick={() => handleChangeOption(category.id)}
            styles={chipsStyles}
            stat={category.formStat}
          />
        ))}
      </FiltersOptionsWrapper>
    </FiltersSection>
  );
};
